import React, { useState, useLayoutEffect } from "react";
import { RouteComponentProps } from "react-router";
import { Grid, Paper } from "@material-ui/core";
import { MobXProviderContext } from "mobx-react";
import useStyles, { STGrid, STWrapper } from "./styles";
import { ThemeProvider } from "styled-components";
import { Values } from "@src/Tools/Values";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import ChangePasswordForm, { IPasswordForm } from "@src/Components/Common/ChangePasswordForm/ChangePasswordForm";
import { IManagementStore } from "@src/Stores/Management/types";
import { RouterStore } from "mobx-react-router";

function useStores() {
    return React.useContext(MobXProviderContext);
}

const handleUpdate = async (values: IPasswordForm, management: IManagementStore, routing: RouterStore) => {
    await management.createPassword(window.location.href, values.password);
    routing.history.push("/login");
};

const handleGoToLogin = (routing: RouterStore) => {
    routing.history.push("/login");
};

const PasswordCreate = (props: RouteComponentProps) => {
    const [isLoading, setIsLoading] = useState(true);
    const { values, routing, themes, management } = useStores();
    const classes = useStyles({});

    useLayoutEffect(() => {
        async function componentDidMount() {
            await themes.getCurrentTheme(values.themeTypes.Login);
            const isLinkValid = await management.validateCreatePasswordLink(window.location.href);
            if (!isLinkValid) {
                routing.history.push("/login");
            }
            document.title = Values.getLocalizationValue("createUserPassword");
            setIsLoading(false);
        }
        if (isLoading) {
            componentDidMount();
        }
    }, []);

    if (isLoading) {
        return null;
    }
    return (
        <ThemeProvider theme={themes.login}>
            <STGrid
                id="reset-page"
                container
                justify="center"
                direction="column"
                alignItems="center"
                className={classes.loginGrid}
                loginbackgroundlandscapeimageurl={themes.login.loginBackgroundLandscapeImageUrl}
                loginbackgroundportraitimageurl={themes.login.loginBackgroundPortraitImageUrl}
                styles={themes.login.css}
            >
                <img id="reset-page-logo" className={classes.loginLogo} src={themes.login.loginLogoImageUrl} />
                <Paper elevation={2} className={classes.paperRoot} id="reset-form">
                    <STWrapper item>
                        <ChangePasswordForm
                            title={Values.getLocalizationValue("createPassword")}
                            onSubmit={(values: IPasswordForm) => handleUpdate(values, management, routing)}
                        >
                            <Grid container justify="flex-end" style={{ display: "flex" }}>
                                <STButtonMargin
                                    variant="contained"
                                    color="default"
                                    style={{ textTransform: "none" }}
                                    onClick={() => handleGoToLogin(routing)}
                                >
                                    {Values.getLocalizationValue("goToLogin")}
                                </STButtonMargin>
                                <STButtonMargin
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    style={{ textTransform: "none", backgroundColor: "green" }}
                                >
                                    {Values.getLocalizationValue("saveNewPassword")}
                                </STButtonMargin>
                            </Grid>
                        </ChangePasswordForm>
                    </STWrapper>
                </Paper>
            </STGrid>
        </ThemeProvider>
    );
};

export default PasswordCreate;
